// Centralized ad-event tracking (impressions + clicks) for video and static ads.
const API = process.env.REACT_APP_BACKEND_URL;

// Where every in-game/static ad click sends the visitor. Opened in a NEW TAB so a
// player never loses the game they're already in.
export const AD_DESTINATION = '/ads';

// Open the ad destination without disrupting the current tab/game.
export const openAdDestination = () => {
  try {
    window.open(AD_DESTINATION, '_blank', 'noopener,noreferrer');
  } catch { /* ignore */ }
};

// Resolve a persistent visitor id: prefer the player's nickname, else an anon id.
export const getVisitorId = () => {
  try {
    const raw = localStorage.getItem('game-storage');
    if (raw) {
      const nick = JSON.parse(raw)?.state?.nickname;
      if (nick && nick.trim()) return nick.trim();
    }
  } catch { /* ignore */ }
  let anon = localStorage.getItem('jb_anon_id');
  if (!anon) {
    anon = 'anon_' + Math.random().toString(36).slice(2, 11);
    localStorage.setItem('jb_anon_id', anon);
  }
  return anon;
};

// Fire-and-forget ad event. payload: { ad_id, ad_name, ad_type, placement, kind }
export const logAdEvent = ({ ad_id, ad_name, ad_type = 'video', placement, kind = 'impression' }) => {
  if (ad_id == null) return;
  try {
    fetch(`${API}/api/ads/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ad_id, ad_name, ad_type, placement, kind, visitor_id: getVisitorId() }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* ignore */ }
};
